import { getBrandedEnvironmentConfig, getFeatureBranchPrefix } from '../configHelper.js';
export var PaginationButtonName;
(function (PaginationButtonName) {
    PaginationButtonName["PageNavigation"] = "pageNavigation";
    PaginationButtonName["MoreButton"] = "moreButton";
})(PaginationButtonName || (PaginationButtonName = {}));
export var ChannelSpecialColors;
(function (ChannelSpecialColors) {
    ChannelSpecialColors["AQUA"] = "aqua";
    ChannelSpecialColors["BLACK"] = "black";
    ChannelSpecialColors["BLUE"] = "blue";
    ChannelSpecialColors["RED"] = "red";
    ChannelSpecialColors["GRAY"] = "gray";
    ChannelSpecialColors["BRAND"] = "brand";
    ChannelSpecialColors["TRANSPARENT"] = "transparent";
})(ChannelSpecialColors || (ChannelSpecialColors = {}));
const definition = {
    base: {
        _: {
            hostname: '',
            origin: '',
            legacyOrigin: '',
            brandPrefix: '',
            brandDescription: '',
            brandSocialLinks: [],
            brandAboutText: '',
            brandLogo: { url: '', width: 0, height: 0 },
            CWCUrl: '',
            f100ChartWidget: {
                isEnabled: false,
                webBaseUrl: 'https://stage-www.finanzen100.de',
                apiBaseUrl: 'https://stage-chart.widget.finanzen100.de',
            },
            mostReadArticleTitlePlaceholder: 'Leere meistgelesene Artikel der Woche',
            newsletterSubscriptionApi: 'https://api.bf-bfnewsletter-sandbox.aws.bfops.io',
            newsletterLdsApi: 'https://lds.bf-lds-production.aws.bfops.io:8000',
            newsletterLdsSlug: 'nl_p1_bf_nleinwilligung',
            pagination: {
                author: {
                    isEnabled: true,
                    pageLimit: 20,
                    teasersPerPage: 50,
                    startOffset: 0,
                    paginationButtonName: PaginationButtonName.PageNavigation,
                },
                channel: {
                    isEnabled: false,
                    pageLimit: 20,
                    teasersPerPage: 50,
                    startOffset: 0,
                    paginationButtonName: PaginationButtonName.PageNavigation,
                },
                tags: {
                    isEnabled: false,
                    pageLimit: 20,
                    teasersPerPage: 16,
                    startOffset: 6,
                    paginationButtonName: PaginationButtonName.PageNavigation,
                },
                hubPages: {
                    isEnabled: true,
                    pageLimit: 20,
                    teasersPerPage: 16,
                    startOffset: 6,
                    paginationButtonName: PaginationButtonName.PageNavigation,
                },
                partner: {
                    isEnabled: true,
                    pageLimit: 20,
                    teasersPerPage: 20,
                    startOffset: 0,
                    paginationButtonName: PaginationButtonName.PageNavigation,
                },
            },
            sitemap: {
                article: { isEnabled: true, interval: 'week' },
                image: { isEnabled: true, interval: 'week' },
                news: { isEnabled: true },
                video: { isEnabled: true, interval: 'month' },
            },
            feed: {
                rss: { isEnabled: true },
                yahoo: { isEnabled: true },
                msn: { isEnabled: true },
                msnGallery: { isEnabled: true },
                msnVideo: { isEnabled: true },
                pushedArticles: { isEnabled: true },
            },
            specialChannelSettings: {
                defaultColor: ChannelSpecialColors.AQUA,
            },
            appView: {
                isEnabled: false,
            },
            cacheTTL: {
                recentArticle: 60,
                oldArticle: 10 * 60,
            },
        },
        focus: {
            hostname: 'focus.de',
            brandPrefix: 'fol',
            brandTitle: 'FOCUS online',
            brandDescription: 'Aktuelle Nachrichten und Analysen aus Politik, Wirtschaft, Sport und Gesellschaft - unabhängig, schnell, informativ',
            brandSocialLinks: [
                'https://www.facebook.com/focus.de',
                'https://www.twitter.com/focusonline',
                'https://de.linkedin.com/company/focus-online-news',
                'https://www.youtube.com/user/focusonline',
                'https://www.xing.com/pages/focus-online-karriere',
                'https://de.wikipedia.org/wiki/Focus_Online',
            ],
            brandAboutText: 'Nachrichtenportal mit aktuellen Themen zu Politik, Wirtschaft, Sport und Gesellschaft',
            brandLogo: {
                url: '/ctf/focus/favicon/fol-logo.png',
                width: 512,
                height: 240,
            },
            f100ChartWidget: {
                isEnabled: true,
                webBaseUrl: 'https://stage-www.finanzen100.de',
                apiBaseUrl: 'https://stage-chart.widget.finanzen100.de',
            },
            sitemap: {
                article: { isEnabled: true, interval: 'week' },
                image: { isEnabled: true, interval: 'week' },
                news: { isEnabled: true },
                video: { isEnabled: true, interval: 'month' },
            },
            specialChannelSettings: {
                defaultColor: ChannelSpecialColors.AQUA,
                availableColors: [ChannelSpecialColors.AQUA, ChannelSpecialColors.RED, ChannelSpecialColors.BLUE],
            },
            articleFeedbackButtonPath: '/static/kontaktformular_59b8c454-2196-4c3d-9446-c67bd4a0dde7.html',
            appView: {
                isEnabled: true,
            },
            cacheTTL: {
                recentArticle: 60 * 60,
                oldArticle: 60 * 60,
            },
            pagination: {
                hubPages: {
                    pageLimit: 10,
                    startOffset: 40,
                    teasersPerPage: 40,
                },
            },
        },
        chip: {
            hostname: 'chip.de',
            brandPrefix: 'chip',
            brandTitle: 'CHIP',
            sitemap: {
                article: { isEnabled: true, interval: 'month' },
                image: { isEnabled: true, interval: 'month' },
                news: { isEnabled: true },
                video: { isEnabled: true, interval: 'month' },
            },
            specialChannelSettings: {
                defaultColor: ChannelSpecialColors.GRAY,
                availableColors: [ChannelSpecialColors.GRAY, ChannelSpecialColors.TRANSPARENT],
            },
        },
        bunte: {
            hostname: 'bunte.de',
            brandDescription: 'Exklusive Promi-News, VIP-News und Videos aus der Welt der Stars und Royals. Auf BUNTE.de bekommst du Entertainment pur und die neusten Lifestyle-Trends.',
            brandPrefix: 'bunte',
            brandTitle: 'BUNTE',
            brandLogo: {
                url: '/ctf/bunte/favicon/logo-bunte-1000.png',
                width: 1000,
                height: 1000,
            },
            appView: {
                isEnabled: true,
            },
            brandSocialLinks: [
                'https://www.instagram.com/bunte',
                'https://www.pinterest.de/buntede/',
                'https://www.facebook.com/bunte.de',
                'https://www.youtube.com/user/BUNTEtv',
                'https://www.tiktok.com/@bunte ',
            ],
            brandAboutText: 'Exklusive Promi-News, VIP-News und Videos aus der Welt der Stars und Royals. Auf BUNTE.de bekommst du Entertainment pur und die neusten Lifestyle-Trends.',
            pagination: {
                author: { pageLimit: 200 },
                channel: { isEnabled: true, pageLimit: 200, teasersPerPage: 50, paginationButtonName: PaginationButtonName.PageNavigation },
                tags: { isEnabled: true, pageLimit: 200 },
                hubPages: { pageLimit: 200, startOffset: 8 },
            },
            sitemap: {
                article: { isEnabled: true, interval: 'month' },
                image: { isEnabled: true, interval: 'month' },
                news: { isEnabled: true },
                video: { isEnabled: true, interval: 'month' },
            },
            specialChannelSettings: {
                defaultColor: ChannelSpecialColors.BLACK,
            },
        },
        fitforfun: {
            hostname: 'fitforfun.de',
            brandPrefix: 'fitforfun',
            brandTitle: 'FIT FOR FUN',
            sitemap: {
                article: { isEnabled: true, interval: 'month' },
                image: { isEnabled: true, interval: 'month' },
                news: { isEnabled: true },
                video: { isEnabled: true, interval: 'month' },
            },
            specialChannelSettings: {
                defaultColor: ChannelSpecialColors.BRAND,
            },
        },
        finanzen100: {
            hostname: 'finanzen100.de',
            brandPrefix: 'f100',
            brandTitle: 'Finanzen100',
            brandDescription: 'Aktuelle Finanznachrichten und Informationen rund um das Thema Börse finden Sie auf Deutschlands innovativstem Finanzportal Finanzen100.',
            brandSocialLinks: [
                'https://www.facebook.com/Finanzen100',
                'https://x.com/Finanzen100',
                'https://www.youtube.com/@Finanzen100',
                'https://www.instagram.com/finanzen100.de',
            ],
            brandAboutText: 'Finanznachrichten und Infos zu Börse und Aktien - Finanzen100',
            appView: {
                isEnabled: true,
            },
            brandLogo: {
                url: '/ctf/finanzen100/favicon/finanzen100-logo.png',
                width: 512,
                height: 240,
            },
            f100ChartWidget: {
                isEnabled: true,
                webBaseUrl: 'https://stage-www.finanzen100.de',
                apiBaseUrl: 'https://stage-chart.widget.finanzen100.de',
            },
            sitemap: {
                article: { isEnabled: true, interval: 'month' },
                image: { isEnabled: true, interval: 'month' },
                news: { isEnabled: true },
                video: { isEnabled: true, interval: 'month' },
            },
        },
        mittier: {
            hostname: 'mit-tier.de',
            brandPrefix: 'mittier',
            brandTitle: 'mit Tier',
            brandDescription: 'Das digitale Magazin rund um Haustiere – Wissen, News und Ratgeber zu Hund und Katze',
            sitemap: {
                article: { isEnabled: true, interval: 'month' },
                image: { isEnabled: true, interval: 'month' },
                news: { isEnabled: true },
                video: { isEnabled: true, interval: 'month' },
            },
        },
        mitsternen: {
            hostname: 'mit-sternen.de',
            brandPrefix: 'mitsternen',
            brandTitle: 'mit Sternen',
            sitemap: {
                article: { isEnabled: true, interval: 'month' },
                image: { isEnabled: true, interval: 'month' },
                news: { isEnabled: true },
            },
        },
        mitbeziehung: {
            hostname: 'mit-beziehung.de',
            brandPrefix: 'mitbeziehung',
            brandTitle: 'mit Beziehung',
        },
        tvtoday: {
            hostname: 'tvtoday.de',
            brandPrefix: 'tvtoday',
            brandTitle: 'TV Today',
            appView: {
                isEnabled: true,
            },
            sitemap: {
                article: { isEnabled: true, interval: 'month' },
                image: { isEnabled: true, interval: 'month' },
                news: { isEnabled: true },
            },
        },
        tvspielfilm: {
            hostname: 'tvspielfilm.de',
            brandPrefix: 'tvspielfilm',
            brandTitle: 'TV Spielfilm',
            appView: {
                isEnabled: true,
            },
            sitemap: {
                article: { isEnabled: true, interval: 'month' },
                image: { isEnabled: true, interval: 'month' },
                news: { isEnabled: true },
            },
        },
    },
    local: {
        // no legacyOrigin locally
        bunte: {
            origin: 'https://ctf-local.bunte.de',
            legacyOrigin: 'https://ctf-local.bunte.de',
            CWCUrl: 'https://widget-stg.bunte.de/',
        },
        chip: {
            origin: 'https://ctf-local.chip.de',
            legacyOrigin: 'https://ctf-local.chip.de',
            CWCUrl: 'https://widget-stg.chip.de/',
        },
        focus: {
            origin: 'https://ctf-local.focus.de',
            legacyOrigin: 'https://ctf-local.focus.de',
            CWCUrl: 'https://widget-stg.focus.de/',
        },
        fitforfun: {
            origin: 'https://ctf-local.fitforfun.de',
            legacyOrigin: 'https://ctf-local.fitforfun.de',
            CWCUrl: 'https://widget-stg.fitforfun.de/',
        },
        finanzen100: {
            origin: 'https://ctf-local.finanzen100.de',
            legacyOrigin: 'https://ctf-local.finanzen100.de',
            CWCUrl: 'https://widget-stg.finanzen100.de/',
        },
        mittier: {
            origin: 'https://ctf-local.mit-tier.de',
            legacyOrigin: 'https://ctf-local.mit-tier.de',
            CWCUrl: 'https://widget-stg.mit-tier.de/',
        },
        mitsternen: {
            origin: 'https://ctf-local.mit-sternen.de',
            legacyOrigin: 'https://ctf-local.mit-sternen.de',
            CWCUrl: 'https://widget-stg.mit-sternen.de/',
        },
        mitbeziehung: {
            origin: 'https://ctf-local.mit-beziehung.de',
            legacyOrigin: 'https://ctf-local.mit-beziehung.de',
            CWCUrl: 'https://widget-stg.mit-beziehung.de/',
        },
        tvtoday: {
            origin: 'https://ctf-local.tvtoday.de',
            legacyOrigin: 'https://ctf-local.tvtoday.de',
            CWCUrl: 'https://widget-stg.tvtoday.de/',
        },
        tvspielfilm: {
            origin: 'https://ctf-local.tvspielfilm.de',
            legacyOrigin: 'https://ctf-local.tvspielfilm.de',
            CWCUrl: 'https://widget-stg.tvspielfilm.de/',
        },
    },
    local_k8s: {
        // no legacyOrigin locally
        bunte: {
            origin: 'https://ctf-local.bunte.de',
            legacyOrigin: 'https://ctf-local.bunte.de',
            CWCUrl: 'https://widget-stg.bunte.de/',
        },
        chip: {
            origin: 'https://ctf-local.chip.de',
            legacyOrigin: 'https://ctf-local.chip.de',
            CWCUrl: 'https://widget-stg.chip.de/',
        },
        focus: {
            origin: 'https://ctf-local.focus.de',
            legacyOrigin: 'https://ctf-local.focus.de',
            CWCUrl: 'https://widget-stg.focus.de/',
        },
        fitforfun: {
            origin: 'https://ctf-local.fitforfun.de',
            legacyOrigin: 'https://ctf-local.fitforfun.de',
            CWCUrl: 'https://widget-stg.fitforfun.de/',
        },
        finanzen100: {
            origin: 'https://ctf-local.finanzen100.de',
            legacyOrigin: 'https://ctf-local.finanzen100.de',
            CWCUrl: 'https://widget-stg.finanzen100.de/',
        },
        mittier: {
            origin: 'https://ctf-local.mit-tier.de',
            legacyOrigin: 'https://ctf-local.mit-tier.de',
            CWCUrl: 'https://widget-stg.mit-tier.de/',
        },
        mitsternen: {
            origin: 'https://ctf-local.mit-sternen.de',
            legacyOrigin: 'https://ctf-local.mit-sternen.de',
            CWCUrl: 'https://widget-stg.mit-sternen.de/',
        },
        mitbeziehung: {
            origin: 'https://ctf-local.mit-beziehung.de',
            legacyOrigin: 'https://ctf-local.mit-beziehung.de',
            CWCUrl: 'https://widget-stg.mit-beziehung.de/',
        },
        tvtoday: {
            origin: 'https://ctf-local.tvtoday.de',
            legacyOrigin: 'https://ctf-local.tvtoday.de',
            CWCUrl: 'https://widget-stg.tvtoday.de/',
        },
        tvspielfilm: {
            origin: 'https://ctf-local.tvspielfilm.de',
            legacyOrigin: 'https://ctf-local.tvspielfilm.de',
            CWCUrl: 'https://widget-stg.tvspielfilm.de/',
        },
    },
    local_e2e: {
        // no legacyOrigin locally
        bunte: {
            origin: 'https://ctf-local.bunte.de',
            legacyOrigin: 'https://ctf-local.bunte.de',
            CWCUrl: 'https://widget-stg.bunte.de/',
        },
        chip: {
            origin: 'https://ctf-local.chip.de',
            legacyOrigin: 'https://ctf-local.chip.de',
            CWCUrl: 'https://widget-stg.chip.de/',
        },
        focus: {
            origin: 'https://ctf-local.focus.de',
            legacyOrigin: 'https://ctf-local.focus.de',
            CWCUrl: 'https://widget-stg.focus.de/',
        },
        fitforfun: {
            origin: 'https://ctf-local.fitforfun.de',
            legacyOrigin: 'https://ctf-local.fitforfun.de',
            CWCUrl: 'https://widget-stg.fitforfun.de/',
        },
        mittier: {
            origin: 'https://ctf-local.mit-tier.de',
            legacyOrigin: 'https://ctf-local.mit-tier.de',
            CWCUrl: 'https://widget-stg.mit-tier.de/',
        },
        finanzen100: {
            origin: 'https://ctf-local.finanzen100.de',
            legacyOrigin: 'https://ctf-local.finanzen100.de',
            CWCUrl: 'https://widget-stg.finanzen100.de/',
        },
        mitsternen: {
            origin: 'https://ctf-local.mit-sternen.de',
            legacyOrigin: 'https://ctf-local.mit-sternen.de',
            CWCUrl: 'https://widget-stg.mit-sternen.de/',
        },
        mitbeziehung: {
            origin: 'https://ctf-local.mit-beziehung.de',
            legacyOrigin: 'https://ctf-local.mit-beziehung.de',
            CWCUrl: 'https://widget-stg.mit-beziehung.de/',
        },
        tvtoday: {
            origin: 'https://ctf-local.tvtoday.de',
            legacyOrigin: 'https://ctf-local.tvtoday.de',
            CWCUrl: 'https://widget-stg.tvtoday.de/',
        },
        tvspielfilm: {
            origin: 'https://ctf-local.tvspielfilm.de',
            legacyOrigin: 'https://ctf-local.tvspielfilm.de',
            CWCUrl: 'https://widget-stg.tvspielfilm.de/',
        },
    },
    test: {
        // no legacyOrigin locally
        bunte: {
            origin: 'https://ctf-local.bunte.de',
            legacyOrigin: 'https://ctf-local.bunte.de',
            CWCUrl: 'https://widget-stg.bunte.de/',
            sitemap: {
                article: { isEnabled: true, interval: 'month' },
                image: { isEnabled: true, interval: 'month' },
                news: { isEnabled: true },
                video: { isEnabled: true, interval: 'month' },
            },
        },
        chip: {
            origin: 'https://ctf-local.chip.de',
            legacyOrigin: 'https://ctf-local.chip.de',
            CWCUrl: 'https://widget-stg.chip.de/',
            sitemap: {
                article: { isEnabled: true, interval: 'month' },
                image: { isEnabled: true, interval: 'month' },
                news: { isEnabled: true },
                video: { isEnabled: true, interval: 'month' },
            },
        },
        focus: {
            origin: 'https://ctf-local.focus.de',
            legacyOrigin: 'https://ctf-local.focus.de',
            CWCUrl: 'https://widget-stg.focus.de/',
            sitemap: {
                article: { isEnabled: true, interval: 'week' },
                image: { isEnabled: true, interval: 'week' },
                news: { isEnabled: true },
                video: { isEnabled: true, interval: 'month' },
            },
        },
        fitforfun: {
            origin: 'https://ctf-local.fitforfun.de',
            legacyOrigin: 'https://ctf-local.fitforfun.de',
            CWCUrl: 'https://widget-stg.fitforfun.de/',
            sitemap: {
                article: { isEnabled: true, interval: 'month' },
                image: { isEnabled: true, interval: 'month' },
                news: { isEnabled: true },
                video: { isEnabled: true, interval: 'month' },
            },
        },
        finanzen100: {
            origin: 'https://ctf-local.finanzen100.de',
            legacyOrigin: 'https://ctf-local.finanzen100.de',
            CWCUrl: 'https://widget-stg.finanzen100.de/',
            sitemap: {
                article: { isEnabled: true, interval: 'month' },
                image: { isEnabled: true, interval: 'month' },
                news: { isEnabled: true },
                video: { isEnabled: true, interval: 'month' },
            },
        },
        mittier: {
            origin: 'https://ctf-local.mit-tier.de',
            legacyOrigin: 'https://ctf-local.mit-tier.de',
            CWCUrl: 'https://widget-stg.mit-tier.de/',
        },
        mitsternen: {
            origin: 'https://ctf-local.mit-sternen.de',
            legacyOrigin: 'https://ctf-local.mit-sternen.de',
            CWCUrl: 'https://widget-stg.mit-sternen.de/',
        },
        mitbeziehung: {
            origin: 'https://ctf-local.mit-beziehung.de',
            legacyOrigin: 'https://ctf-local.mit-beziehung.de',
            CWCUrl: 'https://widget-stg.mit-beziehung.de/',
        },
        tvtoday: {
            origin: 'https://ctf-local.tvtoday.de',
            legacyOrigin: 'https://ctf-local.tvtoday.de',
            CWCUrl: 'https://widget-stg.tvtoday.de/',
        },
        tvspielfilm: {
            origin: 'https://ctf-local.tvspielfilm.de',
            legacyOrigin: 'https://ctf-local.tvspielfilm.de',
            CWCUrl: 'https://widget-stg.tvspielfilm.de/',
        },
    },
    sandbox: {
        // no legacyOrigin on Sandbox (legacy mock server in use)
        bunte: {
            origin: `https://${getFeatureBranchPrefix()}bunte.bf-ctf-sandbox.aws.bfops.io`,
            legacyOrigin: `https://${getFeatureBranchPrefix()}bunte.bf-ctf-sandbox.aws.bfops.io`,
            CWCUrl: 'https://widget-stg.bunte.de/',
        },
        chip: {
            origin: `https://${getFeatureBranchPrefix()}chip.bf-ctf-sandbox.aws.bfops.io`,
            legacyOrigin: `https://${getFeatureBranchPrefix()}chip.bf-ctf-sandbox.aws.bfops.io`,
            CWCUrl: 'https://widget-stg.chip.de/',
        },
        focus: {
            origin: `https://${getFeatureBranchPrefix()}focus.bf-ctf-sandbox.aws.bfops.io`,
            legacyOrigin: `https://${getFeatureBranchPrefix()}focus.bf-ctf-sandbox.aws.bfops.io`,
            CWCUrl: 'https://widget-stg.focus.de/',
        },
        fitforfun: {
            origin: `https://${getFeatureBranchPrefix()}fitforfun.bf-ctf-sandbox.aws.bfops.io`,
            legacyOrigin: `https://${getFeatureBranchPrefix()}fitforfun.bf-ctf-sandbox.aws.bfops.io`,
            CWCUrl: 'https://widget-stg.fitforfun.de/',
        },
        finanzen100: {
            origin: `https://${getFeatureBranchPrefix()}finanzen100.bf-ctf-sandbox.aws.bfops.io`,
            legacyOrigin: `https://${getFeatureBranchPrefix()}finanzen100.bf-ctf-sandbox.aws.bfops.io`,
            CWCUrl: 'https://widget-stg.finanzen100.de/',
        },
        mittier: {
            origin: `https://${getFeatureBranchPrefix()}mit-tier.bf-ctf-sandbox.aws.bfops.io`,
            legacyOrigin: `https://${getFeatureBranchPrefix()}mit-tier.bf-ctf-sandbox.aws.bfops.io`,
            CWCUrl: 'https://widget-stg.mit-tier.de/',
        },
        mitsternen: {
            origin: `https://${getFeatureBranchPrefix()}mit-sternen.bf-ctf-sandbox.aws.bfops.io`,
            legacyOrigin: `https://${getFeatureBranchPrefix()}mit-sternen.bf-ctf-sandbox.aws.bfops.io`,
            CWCUrl: 'https://widget-stg.mit-sternen.de/',
        },
        mitbeziehung: {
            origin: `https://${getFeatureBranchPrefix()}mit-beziehung.bf-ctf-sandbox.aws.bfops.io`,
            legacyOrigin: `https://${getFeatureBranchPrefix()}mit-beziehung.bf-ctf-sandbox.aws.bfops.io`,
            CWCUrl: 'https://widget-stg.mit-beziehung.de/',
        },
        tvtoday: {
            origin: `https://${getFeatureBranchPrefix()}tvtoday.bf-ctf-sandbox.aws.bfops.io`,
            legacyOrigin: `https://${getFeatureBranchPrefix()}tvtoday.bf-ctf-sandbox.aws.bfops.io`,
            CWCUrl: 'https://widget-stg.tvtoday.de/',
        },
        tvspielfilm: {
            origin: `https://${getFeatureBranchPrefix()}tvspielfilm.bf-ctf-sandbox.aws.bfops.io`,
            legacyOrigin: `https://${getFeatureBranchPrefix()}tvspielfilm.bf-ctf-sandbox.aws.bfops.io`,
            CWCUrl: 'https://widget-stg.tvspielfilm.de/',
        },
    },
    development: {
        bunte: {
            origin: 'https://bunte.bf-ctf-development.aws.bfops.io',
            legacyOrigin: 'https://www.dev.bunte.de',
            CWCUrl: 'https://widget-stg.bunte.de/',
        },
        chip: {
            origin: 'https://chip.bf-ctf-development.aws.bfops.io',
            legacyOrigin: 'https://www-staging.chip.de',
            CWCUrl: 'https://widget-stg.chip.de/',
        },
        focus: {
            origin: 'https://focus.bf-ctf-development.aws.bfops.io',
            legacyOrigin: 'https://www-stg.focus.de',
            CWCUrl: 'https://widget-stg.focus.de/',
        },
        fitforfun: {
            origin: 'https://fitforfun.bf-ctf-development.aws.bfops.io',
            legacyOrigin: 'https://fitforfun.bf-ctf-development.aws.bfops.io',
            CWCUrl: 'https://widget-stg.fitforfun.de/',
        },
        mittier: {
            origin: 'https://mit-tier.bf-ctf-development.aws.bfops.io',
            legacyOrigin: 'https://mit-tier.bf-ctf-development.aws.bfops.io',
            CWCUrl: 'https://widget-stg.mit-tier.de/',
        },
        finanzen100: {
            origin: 'https://finanzen100.bf-ctf-development.aws.bfops.io',
            legacyOrigin: 'https://stage-www.finanzen100.de',
            CWCUrl: 'https://widget-stg.finanzen100.de/',
        },
        mitsternen: {
            origin: 'https://mit-sternen.bf-ctf-development.aws.bfops.io',
            legacyOrigin: 'https://mit-sternen.bf-ctf-development.aws.bfops.io',
            CWCUrl: 'https://widget-stg.mit-sternen.de/',
        },
        mitbeziehung: {
            origin: 'https://mit-beziehung.bf-ctf-development.aws.bfops.io',
            legacyOrigin: 'https://mit-beziehung.bf-ctf-development.aws.bfops.io',
            CWCUrl: 'https://widget-stg.mit-beziehung.de/',
        },
        tvtoday: {
            origin: 'https://tvtoday.bf-ctf-development.aws.bfops.io',
            legacyOrigin: 'https://tvtoday.bf-ctf-development.aws.bfops.io',
            CWCUrl: 'https://widget-stg.tvtoday.de/',
        },
        tvspielfilm: {
            origin: 'https://tvspielfilm.bf-ctf-development.aws.bfops.io',
            legacyOrigin: 'https://tvspielfilm.bf-ctf-development.aws.bfops.io',
            CWCUrl: 'https://widget-stg.tvspielfilm.de/',
        },
    },
    staging: {
        // no legacyOrigin on Staging (legacy mock server in use)
        bunte: {
            origin: 'https://bunte.bf-ctf-staging.aws.bfops.io',
            legacyOrigin: 'https://bunte.bf-ctf-staging.aws.bfops.io',
            CWCUrl: 'https://widget-stg.bunte.de/',
        },
        chip: {
            origin: 'https://chip.bf-ctf-staging.aws.bfops.io',
            legacyOrigin: 'https://chip.bf-ctf-staging.aws.bfops.io',
            CWCUrl: 'https://widget-stg.chip.de/',
        },
        focus: {
            origin: 'https://focus.bf-ctf-staging.aws.bfops.io',
            legacyOrigin: 'https://focus.bf-ctf-staging.aws.bfops.io',
            CWCUrl: 'https://widget-stg.focus.de/',
        },
        fitforfun: {
            origin: 'https://fitforfun.bf-ctf-staging.aws.bfops.io',
            legacyOrigin: 'https://fitforfun.bf-ctf-staging.aws.bfops.io',
            CWCUrl: 'https://widget-stg.fitforfun.de/',
        },
        mittier: {
            origin: 'https://mit-tier.bf-ctf-staging.aws.bfops.io',
            legacyOrigin: 'https://mit-tier.bf-ctf-staging.aws.bfops.io',
            CWCUrl: 'https://widget-stg.mit-tier.de/',
        },
        finanzen100: {
            origin: 'https://finanzen100.bf-ctf-staging.aws.bfops.io',
            legacyOrigin: 'https://finanzen100.bf-ctf-staging.aws.bfops.io',
            CWCUrl: 'https://widget-stg.finanzen100.de/',
        },
        mitsternen: {
            origin: 'https://mit-sternen.bf-ctf-staging.aws.bfops.io',
            legacyOrigin: 'https://mit-sternen.bf-ctf-staging.aws.bfops.io',
            CWCUrl: 'https://widget-stg.mit-sternen.de/',
        },
        mitbeziehung: {
            origin: 'https://mit-beziehung.bf-ctf-staging.aws.bfops.io',
            legacyOrigin: 'https://mit-beziehung.bf-ctf-staging.aws.bfops.io',
            CWCUrl: 'https://widget-stg.mit-beziehung.de/',
        },
        tvtoday: {
            origin: 'https://tvtoday.bf-ctf-staging.aws.bfops.io',
            legacyOrigin: 'https://tvtoday.bf-ctf-staging.aws.bfops.io',
            CWCUrl: 'https://widget-stg.tvtoday.de/',
        },
        tvspielfilm: {
            origin: 'https://tvspielfilm.bf-ctf-staging.aws.bfops.io',
            legacyOrigin: 'https://tvspielfilm.bf-ctf-staging.aws.bfops.io',
            CWCUrl: 'https://widget-stg.tvspielfilm.de/',
        },
    },
    production: {
        _: {
            newsletterSubscriptionApi: 'https://api.bf-bfnewsletter-production.aws.bfops.io',
        },
        bunte: {
            origin: 'https://www.bunte.de',
            legacyOrigin: 'https://www.bunte.de',
            CWCUrl: 'https://widget.bunte.de/',
        },
        chip: {
            origin: 'https://www.chip.de',
            legacyOrigin: 'https://www.chip.de',
            CWCUrl: 'https://widget.chip.de/',
        },
        focus: {
            origin: 'https://www.focus.de',
            legacyOrigin: 'https://www.focus.de',
            CWCUrl: 'https://widget.focus.de/',
            f100ChartWidget: {
                isEnabled: true,
                webBaseUrl: 'https://www.finanzen100.de',
                apiBaseUrl: 'https://chart.widget.finanzen100.de',
            },
        },
        fitforfun: {
            origin: 'https://www.fitforfun.de',
            legacyOrigin: 'https://www.fitforfun.de',
            CWCUrl: 'https://widget.fitforfun.de/',
        },
        finanzen100: {
            origin: 'https://www.finanzen100.de',
            legacyOrigin: 'https://www.finanzen100.de',
            CWCUrl: 'https://widget.finanzen100.de/',
            f100ChartWidget: {
                isEnabled: true,
                webBaseUrl: 'https://www.finanzen100.de',
                apiBaseUrl: 'https://chart.widget.finanzen100.de',
            },
        },
        mittier: {
            origin: 'https://www.mit-tier.de',
            legacyOrigin: 'https://www.mit-tier.de',
            CWCUrl: 'https://widget.mit-tier.de/',
        },
        mitsternen: {
            origin: 'https://www.mit-sternen.de',
            legacyOrigin: 'https://www.mit-sternen.de',
            CWCUrl: 'https://widget.mit-sternen.de/',
        },
        mitbeziehung: {
            origin: 'https://www.mit-beziehung.de',
            legacyOrigin: 'https://www.mit-beziehung.de',
            CWCUrl: 'https://widget.mit-beziehung.de/',
        },
        tvtoday: {
            origin: 'https://www.tvtoday.de',
            legacyOrigin: 'https://www.tvtoday.de',
            CWCUrl: 'https://widget.tvtoday.de/',
        },
        tvspielfilm: {
            origin: 'https://www.tvspielfilm.de',
            legacyOrigin: 'https://www.tvspielfilm.de',
            CWCUrl: 'https://widget.tvspielfilm.de/',
        },
    },
};
export const renderingBrandConfig = (brand) => getBrandedEnvironmentConfig(definition, brand);
//# sourceMappingURL=rendering.brand.config.js.map